export const StorageKeys = {
  socketScannerConnectedKey: 'socketScannerConnected',
  loggedUserData: 'loggedUserData',
  activeEmployee: 'activeEmployee',
  activeStore: 'activeStore-',
  defaultSecondPaymentMethod: 'defaultSecondPaymentMethod',
  selectedPaymentMethod: 'selectedPaymentMethod',
  lastUsedVatRate: 'lastUsedVatRate',
  activeTerminal: 'activeTerminal',
  preferredLanguage: 'preferredLanguage',
  companyLogo: 'companyLogo',
  invoicesKeepDurationKey: 'invoicesKeepDuration',
  settings: {
    oneClickPaymentStatusKey: 'settings.onclickpaymentstatus',
    defaultPaymentMethodKey: 'settings.defaultpaymentmethod',
    tippingStatusKey: 'settings.tippingstatus',
    defaultTipProductKey: 'settings.defaulttipproduct',
    multipleGuestsStatusKey: 'settings.multipleGuestsStatus',
    onInvoicePaymentStatusKey: 'settings.onInvoicePaymentStatus',
    device: 'settings.device',
    autoPrintingKitchenReceiptOnlineInvoice: 'autoPrintingKitchenReceiptOnlineInvoice',
  },
  showSumUpRecommendation: 'showSumUpRecommendation',
  printersSettings: 'printersSettings',
  initialPaidInvoicesStatus: 'initialPaidInvoicesStatus',
  permissions: 'permissions',
  showMessageOneTime: 'showMessageOneTime',
  paymashPayKey: 'paymashPayKey',
  paymashPayMerchantId: 'paymashPayMerchantId',
  deviceIdentifier: 'deviceIdentifier',
  deviceFingerprint: 'deviceFingerprint',
  debugAleternateApiInput: 'debugAleternateApiInput',
  enableLogs: 'enableLogs',
  sunmiPrinterInfo: 'sunmiPrinterInfo',
  numberOfProductsInRowOnCollectionView: 'numberOfProductsInRowOnCollectionView',
  adyenTerminalStatusConnectionState: 'adyenTerminalStatusConnectionState',
  paymashPayLastTransactionMap: 'paymashPayLastTransactionMap',
  targetDevice: 'targetDevice',
  fullDeviceInfo: 'fullDeviceInfo',
};
